import colors from '@/config/colors';
import { Linking } from 'react-native';
import { Text } from '@/components/Text';
import { TextProps } from 'react-native-elements';

export function TextLink({
  href,
  children,
  ...props
}: TextProps & { href: string }) {
  function handlePressLink() {
    Linking.openURL(href);
  }

  return (
    <Text
      onPress={handlePressLink}
      style={{
        color: colors.darkPurpleBlue,
      }}
      {...props}
    >
      {children}
    </Text>
  );
}
